import { cnpj } from 'cpf-cnpj-validator';

const validate = (values) => {
  const errors = {};
  if (!values.reasonName) {
    errors.reasonName = 'Esse campo não pode ficar vazio';
  }
  if (!values.fantasyName) {
    errors.fantasyName = 'Esse campo não pode ficar vazio';
  }
  if (!values.responsible) {
    errors.responsible = 'Esse campo não pode ficar vazio';
  }
  if (values.cnpj) {
    const cnpjIsValid = cnpj.isValid(values.cnpj);
    if (!cnpjIsValid) {
      errors.cnpj = 'Informe um CNPJ válido!';
    }
  } else {
    errors.cnpj = 'Esse campo não pode ficar vazio';
  }
  if (values.zipCode) {
    if (values.zipCode.trim().length < 8) {
      errors.zipCode = 'CEP Inválido';
    }
  } else {
    errors.zipCode = 'CEP Inválido';
  }
  if (!values.address) {
    errors.address = 'Esse campo não pode ficar vazio';
  }
  if (!values.addressNumber) {
    errors.addressNumber = 'Esse campo não pode ficar vazio';
  }
  if (!values.neighborhood) {
    errors.neighborhood = 'Esse campo não pode ficar vazio';
  }
  if (!values.state) {
    errors.state = 'Esse campo não pode ficar vazio';
  }
  if (!values.city) {
    errors.city = 'Esse campo não pode ficar vazio';
  }
  if (!values.phoneOne) {
    errors.phoneOne = 'Telefone inválido';
  }
  if (!values.email) {
    errors.email = 'Este campo não pode ficar vazio';
  }
  if (!values.startTime) {
    errors.startTime = 'Hora inválida';
  }
  if (!values.finalTime) {
    errors.finalTime = 'Hora inválida';
  }
  if (values.startTime && values.finalTime) {
    const startTime = Number(values.startTime.replace(':', ''));
    const finalTime = Number(values.finalTime.replace(':', ''));
    if (startTime > finalTime) {
      errors.startTime = 'Hora inicial não pode ser maior que hora final';
    }
  }
  if (values.workingDays) {
    const selectedDaysToString = String(values.workingDays);
    if (selectedDaysToString.indexOf('1') === -1) {
      errors.workingDays = 'Nenhum dia útil foi informado';
    }
  }
  return errors;
};

export default validate;
